import { cloneDeep } from "lodash";
import { AnyAction } from "redux";
import Company from "../../models/core/company/Company";
import {
  CHANGE_CURRENT_COMPANY,
  CHANGE_CURRENT_PROFILE,
  CHANGE_CURRENT_DEPENDENTE,
  LOGIN_USER,
  LOGOUT_USER,
  PHOTO_USER,
  RESET,
  UPDATE_USER_INFO,
  LOGIN_USER_DEPENDENTE
} from "../actions/login";

export interface ILoginCompany {
  id: string;
  nome: string;
  perfis: string[];
}

export interface ILoginQuestionary {
  questionarioId: string;
  avaliacaoRespondida: {
    avaliacaoId: string;
    finalizada: boolean;
    respondidaEm: string;
  };
}

export interface ILoginUserInfo {
  id: string;
  nome: string;
  cpf: string;
  comoSerChamado: string;
  foto: any;
  cadastroIncompleto: boolean;
  empresas: ILoginCompany[];
  questionarios: ILoginQuestionary[];
}

export interface ILogin {
  keepConnected: boolean;
  user: string | null;
  userInfo?: ILoginUserInfo | null;
  token: string | null;
  refreshToken: string | null;
  roles: string[];
  userCompanies: Company[] | null;
  currentCompany: Company | null;
  currentProfile: string | null;
  userRetrievePass: string | null;
  emailRetrievePass: string | null;
  tokenType: string | null;
  photo: any | null;
  dependentes: any;
  currentDependente: string | null;
  dependenteProfile: boolean;
}

const company1: Company = new Company().fromJSON({
  administradorEmpresa: {
    nome: "Marcos Vinicius Vilela de Macedo XyZ",
    telefone: "8130236780",
    telefone2: "81997697018",
    cpf: "11810673089",
    email: "mvmacedo1yax@stefanini.com",
  },
  responsavelEmpresa: {
    nome: "Fulano de tal XyZ",
    telefone: "8134316505",
    telefone2: null,
    cpf: "15027299036",
    email: "mvvmxxy@ecomp.poli.br",
  },
  telefones: ["8134316505"],
  endereco: {
    bairro: "Asdasda Xxyy",
    cep: "53140018",
    cidade: "Olinda Xxyy",
    complemento: "Complemento xXyy",
    estado: "DF",
    logradouro: "Rua Carlos Paulino Xxyy",
    numero: "195",
  },
  id: "90e7dc10-93bd-4bd3-b2ed-5b66e376ff00",
  inativo: false,
  nomeFantasia: "BRASKEM XXy",
  razaoSocial: "Future Foundation",
  cnpj: "34941196000130",
});

const company2: Company = new Company().fromJSON({
  administradorEmpresa: {
    nome: "Marcos Vinicius Vilela de Macedo XyZ",
    telefone: "8130236780",
    telefone2: "81997697018",
    cpf: "11810673089",
    email: "mvmacedo1yax@stefanini.com",
  },
  responsavelEmpresa: {
    nome: "Fulano de tal XyZ",
    telefone: "8134316505",
    telefone2: null,
    cpf: "15027299036",
    email: "mvvmxxy@ecomp.poli.br",
  },
  telefones: ["8134316505"],
  endereco: {
    bairro: "Asdasda Xxyy",
    cep: "53140018",
    cidade: "Olinda Xxyy",
    complemento: "Complemento xXyy",
    estado: "DF",
    logradouro: "Rua Carlos Paulino Xxyy",
    numero: "195",
  },
  id: "b72a8762-612f-4d26-80f4-6d1a128adda8",
  inativo: false,
  nomeFantasia: "Future Foundation",
  razaoSocial: "Future Foundation",
  cnpj: "34941196000130",
});

const initialState: ILogin = {
  keepConnected: false,
  user: null,
  userInfo: null,
  token: null,
  refreshToken: null,
  userRetrievePass: null,
  emailRetrievePass: null,
  roles: [],
  userCompanies: [],
  currentCompany: null,
  currentProfile: null,
  tokenType: null,
  photo: null,
  dependentes: [],
  currentDependente: null,
  dependenteProfile: false
};

export const LoginReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case RESET: {
      return {
        ...cloneDeep(initialState),
      };
    }
    case LOGIN_USER: {
      return {
        ...cloneDeep(state),
        keepConnected: action.keepConnected,
        user: action.username,
        userInfo: action.userInfo,
        token: action.token,
        refreshToken: action.refreshToken,
        roles: action.roles,
        currentCompany: action.currentCompany,
        userCompanies: action.companies,
        currentProfile: action.currentRole,
        tokenType: action.tokenType,
        photo: action.photo,
        dependentes: action.dependentes,
        currentDependente: action.currentDependente,
        dependenteProfile: action.dependenteProfile
      };
    }
    case LOGIN_USER_DEPENDENTE: {
      return {
        ...cloneDeep(state),
        keepConnected: action.keepConnected,
        user: action.username,
        userInfo: action.userInfo,
        token: action.token,
        refreshToken: action.refreshToken,
        roles: action.roles,
        currentCompany: action.currentCompany,
        userCompanies: action.companies,
        currentProfile: action.currentRole,
        tokenType: action.tokenType,
        photo: action.photo,
        dependentes: action.dependentes,
        currentDependente: action.currentDependente,
        dependenteProfile: action.dependenteProfile
      };
    }
    case LOGOUT_USER: {
      return {
        ...cloneDeep(state),
        keepConnected: false,
        user: null,
        token: null,
        roles: [],
      };
    }
    case CHANGE_CURRENT_COMPANY: {
      return {
        ...cloneDeep(state),
        currentCompany: action.currentCompany,
        currentProfile: action.currentProfile,
      };
    }
    case CHANGE_CURRENT_PROFILE: {
      return {
        ...cloneDeep(state),
        currentProfile: action.currentProfile,
      };
    }
    case CHANGE_CURRENT_DEPENDENTE: {
      return {
        ...cloneDeep(state),
        currentDependente: action.currentDependente,
      };
    }    
    case UPDATE_USER_INFO: {
      return {
        ...cloneDeep(state),
        userInfo: action.userInfo,
        currentCompany: action.currentCompany,
        userCompanies: action.companies,
        currentProfile: action.currentRole,
      };
    }
    case PHOTO_USER: {
      return {
        ...cloneDeep(state),
        photo: action.photo,
      };
    }  
    default: {
      return state;
    }
  }
};
